import { type DefaultParamType } from '@tolgee/react'
import type { Namespace } from './generated/i18n-meta'
import type Resources from './generated/i18n-types'

export interface DeepRecord {
  [key: string]: DeepRecord
}

export type SingleNamespaceSelectorProxy<NS extends Namespace> = Resources[NS]

export type MultiNamespaceSelectorProxy = DeepRecord

export type SelectorProxy<NS extends Namespace | readonly Namespace[]> =
  NS extends readonly Namespace[]
    ? MultiNamespaceSelectorProxy
    : NS extends Namespace
      ? SingleNamespaceSelectorProxy<NS>
      : never

export type SelectorFunction<NS extends Namespace | readonly Namespace[]> = (
  $: SelectorProxy<NS>
) => unknown

export type TranslateOptions = Record<string, DefaultParamType>

export type TranslateFunction<NS extends Namespace | readonly Namespace[]> = {
  (selector: SelectorFunction<NS>, options?: TranslateOptions): string
  (key: string, options?: TranslateOptions): string
}

export type UseTranslationsResult<NS extends Namespace | readonly Namespace[]> = {
  t: TranslateFunction<NS>
}

export type TFunction<NS extends Namespace = 'common', _Context = undefined> = TranslateFunction<NS>

export type { TolgeeInstance } from '@tolgee/react'
